/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import { useQuery } from '@tanstack/react-query'

const ACTION_BASE = process.env.REACT_APP_ACTION_URL || ''

let flagsEtag = null
let flagsCache = null

const FLAG_DEFAULTS = {
  galleryEnabled: false,
  selfieEnabled: false,
  probeScheduleEnabled: false,
  probeFeedEnabled: false,
  probeDiscoverEnabled: false,
  groupChatEnabled: false,
  speakerChatEnabled: false,
}

const fetchFeatureFlags = async () => {
  const headers = {}
  if (flagsEtag) headers['If-None-Match'] = flagsEtag

  const res = await fetch(`${ACTION_BASE}/booking-admin/feature-flags`, {
    headers,
  })
  if (res.status === 304 && flagsCache) return flagsCache
  if (!res.ok) return flagsCache || { ...FLAG_DEFAULTS }

  const etag = res.headers.get('ETag')
  if (etag) flagsEtag = etag
  try {
    flagsCache = await res.json()
  } catch {
    return flagsCache || { ...FLAG_DEFAULTS }
  }
  return flagsCache
}

export const useFeatureFlags = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['feature-flags'],
    queryFn: fetchFeatureFlags,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  })
  return { ...FLAG_DEFAULTS, ...(data || {}), isLoading }
}
